import Typography from "../../ui/widgets/typography";
import { useMessageSource } from "react-message-source";
import SectionFullWidthContainer from "../../ui/layout/page/forms-container/section-full-width-container";
import TypographyContainer from "../../ui/layout/page/typography-container/typography-base-container";
import CheckboxContainer from "../../ui/layout/page/forms-container/form-item-container/checkbox-container";
import CheckboxField from "../shared/components/formik/checkbox";

export const MarketingEmails = () => {
  const { getMessage } = useMessageSource();

  return (
    <SectionFullWidthContainer hasAdditionalTopMargin>
      <TypographyContainer>
        <Typography variant="h4" className="scd-container-base-small">
          {getMessage("MarketingEmails-title")}
        </Typography>
      </TypographyContainer>
      <CheckboxContainer>
        <CheckboxField
          name="acceptMarketingEmails"
          label={getMessage("MarketingEmails.accept")}
        />
      </CheckboxContainer>
    </SectionFullWidthContainer>
  );
};
